import * as React from 'react';
import GridOutlined from './grid-outlined';
import GridFilled from './grid-filled';
import type { IconCombinedProps } from './types';
const GridCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <GridFilled ref={ref} {...rest} />;
  }
  return <GridOutlined ref={ref} {...rest} />;
});
export default GridCombined;